<template>
  <div>
    <b-container fluid>
      <b-row class="mt-3 mb-3">
        <b-col sm="12" md="10" offset-md="1" class="content-container">
          <b-row class="mt-3">
            <b-col cols="12">
              <h2>{{$t('keywordsTable.title')}}</h2>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="12" md="3" class="mb-1">
              <label for="keyword-filter-input">{{$t('keywordsTable.keywordFilterLabel')}}</label>
              <b-form-input
                id="keyword-filter-input"
                :placeholder="$t('keywordsTable.keywordFilterPlaceholder')"
                v-model="filter.word"
              ></b-form-input>
            </b-col>
            <b-col sm="12" md="4" offset-md="5">
              <b-button
                class="add-keyword-btn"
                variant="primary"
                @click="addKeywords"
              >
                <span class="fa fa-plus"> {{$t('keywordsTable.createKeyword')}}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3" v-if="!showSimpleTable">
            <b-col cols="12">
              <b-table
                :fields="fields"
                :items="keywords(filter)"
                :current-page="currentPage"
                :per-page="perPage"
                :busy="loading"
                outlined
                show-empty
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="pl-2">{{$t('keywordsTable.tableLoading')}}</strong>
                  </div>
                </template>

                <template v-slot:empty="scope">
                  <p>{{$t('keywordsTable.tableEmpty')}}</p>
                </template>

                <template v-slot:head(word)>
                  {{$t('keywordsTable.tableKeyword')}}
                </template>

                <template v-slot:cell(word)="data">
                  {{data.item.word}}
                </template>

                <template v-slot:head(language)>
                  {{$t('keywordsTable.tableLanguage')}}
                </template>

                <template v-slot:cell(language)="data">
                  {{data.item.language}}
                </template>

                <template v-slot:head(actions)>
                  {{$t('keywordsTable.tableActions')}}
                </template>

                <template v-slot:cell(actions)="data">
                  <span
                    class="fas fa-trash-alt hover hover-danger"
                    @click="removeKeyword(data.item)"
                  ></span>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="12">
              <b-table
                :fields="simpleFields"
                :items="keywords(filter)"
                :current-page="currentPage"
                :per-page="perPage"
                :busy="loading"
                outlined
                show-empty
                hover
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="pl-2">{{$t('keywordsTable.tableLoading')}}</strong>
                  </div>
                </template>

                <template v-slot:empty="scope">
                  <p>{{$t('keywordsTable.tableEmpty')}}</p>
                </template>

                <template v-slot:head(keyword)>
                  {{$t('keywordsTable.tableKeyword')}}
                </template>

                <template v-slot:cell(keyword)="data">
                  <b-row @click="removeKeyword(data.item)">
                    <b-col cols="12">
                      <p class="mb-0">
                        {{data.item.word}}
                        <span class="small float-right text-black-50">{{data.item.language}}</span>
                      </p>
                    </b-col>
                  </b-row>
                </template>

              </b-table>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col cols="12" class="my-1">
              <b-pagination
                class="float-right my-0"
                :total-rows="keywords(filter).length"
                :per-page="perPage"
                v-model="currentPage"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CreateKeywordsModal from './CreateKeywordsModal.vue';

  export default {
    computed: mapGetters({
      keywords: 'keywords/filterKeywords',
    }),
    data() {
      return {
        loading: true,
        perPage: 25,
        currentPage: 1,
        filter: {
          word: '',
        },
        fields: [
          'word',
          'language',
          'actions',
        ],
        simpleFields: [
          'keyword',
        ],
        showSimpleTable: window.innerWidth < 768,
      };
    },
    mounted() {
      this.getKeywords();
      window.addEventListener('resize', () => {
        const newWidth = window.innerWidth;
        this.showSimpleTable = newWidth < 768;
      });
    },
    methods: {
      getKeywords() {
        this.$store.dispatch('keywords/getKeywords')
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.$toasted.error('Error fetching your keywords.');
          });
      },
      addKeywords() {
        this.$modal.show(CreateKeywordsModal, {}, {
          height: 'auto',
        }, {});
      },
      removeKeyword(keyword) {
        this.$swal({
          title: this.$t('keywordsTable.keywordRemoveTitle'),
          text: this.$t('keywordsTable.keywordRemoveText', { keyword: keyword.word }),
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        })
          .then((willDelete) => {
            if (!willDelete) {
              return;
            }
            this.$store.dispatch('keywords/deleteKeyword', keyword.id)
              .then(() => {
                this.$toasted.success(this.$t('keywordsTable.keywordRemoveSuccess', { keyword: keyword.word }));
              })
              .catch(() => {
                this.$toasted.error(this.$t('keywordsTable.keywordRemoveError'));
              });
          });
      },
    },
  };
</script>

<style scoped>
  .add-keyword-btn {
    top: 50%;
    position: relative;
    transform: translateY(-50%);
    float: right;
  }

  @media only screen and (max-width: 767px) {
    .add-keyword-btn {
      width: 100%;
    }
  }
</style>
